import { useCallback } from 'react';
import { formatIntlCurrency } from 'I18n/utils/formatIntlCurrency';
import { getPriceProperty } from 'commerce-products-lib/utils/currency';
import { PRODUCT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { isPricingModelTiered } from 'customer-data-objects/product/Pricing';
import { getProperty } from 'customer-data-objects/record/ObjectRecordAccessors';
import FormattedPropertyV2 from 'customer-data-properties/formatted/FormattedPropertyV2';
import { Text } from 'foundations-components/components/Text';
import { Section } from 'foundations-components/transitional/components/Section';
import { View } from 'foundations-components/transitional/components/View';
import { useProductCurrencies } from '../../contexts/ProductCurrencyContext';
import { useProductData } from '../../contexts/ProductDataContext';
import { useProductId } from '../../contexts/ProductIdContext';
import { useProductProperties } from '../../contexts/ProductPropertiesContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EMPTY_VALUE = '--';
const emptyFunction = () => undefined;
export const PriceSection = () => {
  const productProperties = useProductProperties();
  const productData = useProductData();
  const productId = useProductId();
  const {
    defaultCurrencyCode,
    isMulticurrencyActive
  } = useProductCurrencies();
  const priceProperty = getPriceProperty(productProperties, isMulticurrencyActive ? defaultCurrencyCode : undefined);
  const getSavedValue = useCallback(propertyName => {
    if (!productData) {
      return undefined;
    }
    return getProperty(productData, propertyName);
  }, [productData]);
  if (!productData || priceProperty === undefined) {
    return null;
  }
  const pricingModelValue = getProperty(productData, 'hs_pricing_model');
  const isTieredPricingModel = isPricingModelTiered(pricingModelValue);
  const pricePropertyName = priceProperty.name;
  const priceValue = getProperty(productData, pricePropertyName);
  if (isTieredPricingModel) {
    return /*#__PURE__*/_jsxs(Section, {
      paddingInlineStart: "500",
      marginBlockStart: "100",
      children: [priceProperty === null || priceProperty === void 0 ? void 0 : priceProperty.label, ":", /*#__PURE__*/_jsx(View, {
        as: "span",
        marginInlineStart: "200",
        children: /*#__PURE__*/_jsx(FormattedPropertyV2, {
          property: priceProperty,
          getDraftValue: emptyFunction,
          getSavedValue: getSavedValue,
          objectTypeId: PRODUCT_TYPE_ID,
          objectId: productId.toString(),
          value: priceValue
        })
      })]
    });
  }
  const priceToDisplay = priceValue === undefined ? EMPTY_VALUE : formatIntlCurrency(Number(priceValue), {
    currencyCode: defaultCurrencyCode
  });
  return /*#__PURE__*/_jsx(Section, {
    paddingInlineStart: "500",
    marginBlockStart: "100",
    children: /*#__PURE__*/_jsxs(Text, {
      children: [priceProperty === null || priceProperty === void 0 ? void 0 : priceProperty.label, ": ", priceToDisplay]
    })
  });
};